import { Injectable } from '@angular/core';
import {PtyWsService} from "./pty-ws.service";
import {PtyLdService} from "./pty-ld.service";

const md5 = require('md5');

@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    translation: any;
    default = {};
    isUsingDefault = true;
    public refreshTimestamp = (new Date()).getTime();

    constructor(
        private ws: PtyWsService,
        private ld: PtyLdService
    ) {
        this.default = require('../../assets/i18n/en.json');
        if (localStorage.getItem('app_translation')) {
            const data = localStorage.getItem('app_translation');
            this.translation = JSON.parse(data);
            this.translation = {...this.default, ...this.translation};
            this.isUsingDefault = false;
        } else {
            this.translation = this.default;
        }

        // Needed to avoid circular dependency
        setTimeout(() => this.ld.setTimeoutErrorMessage(this.translate(this.ld.getTimeoutErrorMessage())), 30000);
    }

    triggerRefresh() {
        // Update the refresh timestamp to now. Any translation pipes that have this attribute bound to them as a parameter should refresh
        this.refreshTimestamp = (new Date()).getTime();
    }

    /* check to see if this.translation matches what is currently in localstorage app_translation */
    languageMatches(){
        let currentLanguageStr =  JSON.stringify(this.translation);
        let localStorageStr = localStorage.getItem('app_translation');
        return currentLanguageStr === localStorageStr;
    }

    hasCachedTranslations() {
        return !!localStorage.getItem('app_translation');
    }

    translate(value) {
        if (!this.languageMatches() && this.hasCachedTranslations()) {
            const data = localStorage.getItem('app_translation');
            this.translation = JSON.parse(data);
            this.translation = {...this.default, ...this.translation};
            localStorage.setItem('app_translation', JSON.stringify(this.translation));
            this.isUsingDefault = false;
        }

        let translation = 'N/A';
        if (this.translation.hasOwnProperty(value)) {
            return this.translation[value];
        }

        const hash = md5(value);
        if (this.translation.hasOwnProperty(hash)) {
            return this.translation[hash];
        }

        const data = {
            phrase: value,
            category: null,     // TODO: Add phrase categories
        };
        this.translation[hash] = value;
        localStorage.setItem('app_translation', JSON.stringify(this.translation));
        this.ws.invokeURL('add_phrase', data);      // Don't care about return value, just inserting to db

        return value;
    }
}
